import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { LehtikoneApiService } from '../services/lehtikone-api.service';
import { Response } from '@angular/http';

@Injectable()
export class DataResolve implements Resolve<any> {

  constructor(private lehtikoneApi: LehtikoneApiService) {}

  resolve( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ): Observable<Response> {
    return this.lehtikoneApi.getData(route.params.path);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolves/data.resolve.ts